(function () {
  var COUNTRIES = ['australia', 'usa', 'europe', 'japan'];

  function init(table) {
    if (table.dataset.sgInit || !table.rows[0]) return;
    var cols = [];
    Array.prototype.forEach.call(table.rows[0].cells, function (cell, i) {
      var name = cell.textContent.trim();
      if (COUNTRIES.indexOf(name.toLowerCase()) > -1) {
        cols.push({ index: i, name: name });
      }
    });
    if (cols.length < 2) return;
    table.dataset.sgInit = '1';

    var tabs = document.createElement('div');
    tabs.className = 'sg-tabs';
    cols.forEach(function (c, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sg-tab';
      b.textContent = c.name;
      b.addEventListener('click', function () { show(n); });
      tabs.appendChild(b);
    });

    var anchor = table.parentNode;
    anchor.parentNode.insertBefore(tabs, anchor);

    function show(active) {
      Array.prototype.forEach.call(table.rows, function (row) {
        cols.forEach(function (c, k) {
          var cell = row.cells[c.index];
          if (cell) cell.style.display = (k === active ? '' : 'none');
        });
      });
      Array.prototype.forEach.call(tabs.children, function (b, k) {
        b.classList.toggle('is-active', k === active);
      });
    }

    show(0); 
  }

  function scan() {
    document.querySelectorAll('.sizeGuideTable').forEach(init);
  }

  scan();
  
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
